import { Component, Input } from '@angular/core';

export interface ExitFeeYearRatios {
  exitFeeRatioYear1: number,
  exitFeeRatioYear2: number,
  exitFeeRatioYear3: number,
  exitFeeRatioYear4: number,
  exitFeeRatioYear5: number,
}

export enum FeeInfoItemTypes {
  EXIT = 'EXIT',
  MANAGEMENT = 'MANAGEMENT',
  SERVICE = 'SERVICE',
  PERFORMANCE = 'PERFORMANCE',
}

@Component({
  selector: 'libero-entry-fee-info-item',
  templateUrl: './entry-fee-info-item.html',
  styleUrl: './entry-fee-info-item.scss',
  standalone: false,
})
export class EntryFeeInfoItemComponent {
  @Input({ required: true }) public type!: FeeInfoItemTypes;
  @Input({ required: true }) public value!: number;
  @Input() public exitFeeTooltipValues?: ExitFeeYearRatios;
  @Input() public useStrategyStyling = false;

  public feeInfoItemTypes = FeeInfoItemTypes;
}
